export default () => ({
  status,
  canceled: false,
  messageStatus: "",
  showSchedule: false,
  weekdays: [],
  temp: {},
  fanspeed: {},
  light: {},
  marquise: {},
  additionalControls: false,
  types: [],
  items: [],
  selectedType: undefined,
  statusGet: undefined,
  statusSet: undefined,
  targetId: "",
  state: {},
});
